module.exports = scope;

function scope(state) {
  if (this.constructor !== scope) return new scope(state);

  this.state = state;
  this.scopes = [];
  this.current = null;
}

const cons = scope,
  proto = cons.prototype;

proto.enter = function (s) {
  this.scopes.push((this.current = this.state[0].scope = s || {}));
};

proto.exit = function () {
  this.scopes.pop();
  this.current = this.scopes[this.scopes.length - 1];
};

proto.define = function (str) {
  this.current[str] = this.state[0];
};

proto.find = function (name, fail) {
  for (let i = this.scopes.length - 1; i > -1; --i) {
    if (this.scopes[i].hasOwnProperty(name)) {
      return this.scopes[i][name];
    }
  }

  return null;
};
